import { Box, Divider, Group, Stack, Text } from '@mantine/core';

import type { ArenaRun, ReportError } from '../hooks/useModelArena';
import { groupByDay, isInFlight } from '../runGrouping';

import { RunRow } from './RunRow';

/**
 * Settled runs, newest first, under the day they ran.
 *
 * Anything still queued or running is left out: it is shown once, in the tab's own in-flight table,
 * where it is visible without expanding a task and to whoever did not queue it.
 */
export function RunHistory({
  runs,
  rankMetric,
  reportError,
}: {
  runs: ArenaRun[];
  rankMetric: string | null;
  reportError: ReportError;
}) {
  return (
    <>
      {groupByDay(runs.filter(run => !isInFlight(run))).map(({ day, runs: dayRuns }) => (
        <Box key={day}>
          <Divider
            my="xs"
            labelPosition="left"
            label={<DayLabel day={day} count={dayRuns.length} />}
          />
          <Stack gap={6}>
            {dayRuns.map(run => (
              <RunRow key={run.id} run={run} rankMetric={rankMetric} reportError={reportError} />
            ))}
          </Stack>
        </Box>
      ))}
    </>
  );
}

function DayLabel({ day, count }: { day: string; count: number }) {
  return (
    <Group gap="xs">
      <Text size="xs" fw={600} c="dimmed" tt="uppercase">
        {day}
      </Text>
      <Text size="xs" c="dimmed">
        {count}
      </Text>
    </Group>
  );
}
